export default "/static/build/pay-pal.png";